<section class="calendar w-full">
  @if (calendarOptions()) {
    <full-calendar #calendar [options]="calendarOptions()">
      <ng-template #eventContent let-arg>
        @let isUnresolved = isAppuntamentoUnresolved(arg.event);
        @let canDragEvent =
          !isEventInPast(arg.event) && arg.event.startEditable;
        @let isAssenzaCard = isAssenzaEvent(arg.event);
        @let isPromemoriaCard = isPromemoriaEvent(arg.event);
        @let isTurnoCard = isTurnoEvent(arg.event);
        @let isAllDay = arg.event.allDay;
        @let isShortEvent = arg.isShort;
        @let isMonthView = arg.view?.type === 'dayGridMonth';
        @let isMacchinarioCard = hasMachinery(arg.event);
        @let isDisponibilitaMacchinario =
          arg.event.groupId === 'disponibilita-macchinario';
        @let hasMatchingPrestazione =
          arg.event.extendedProps?.hasMatchingPrestazione;
        @let isTravelCard = isTravelEvent(arg.event);
        @if (
          !isDisponibilitaMacchinario &&
          !(
            arg.event.extendedProps?.headerTrascinabile &&
            arg.event.display === 'background'
          )
        ) {
          <div
            class="event-content-wrapper"
            [ngClass]="{
              'cursor-grab!': canDragEvent,
              'cursor-default!': !canDragEvent,
              'event-unresolved': isUnresolved,
              'event-allday-content': isAllDay,
              'event-promemoria-compatto': isPromemoriaCard,
              'event-defocused': focusPrestazione() && !hasMatchingPrestazione,
            }"
            siatCustomToolTip
            [showToolTip]="
              customOptions()?.showTooltip &&
              hasMatchingPrestazione &&
              !isTravelCard
            "
            [contentTemplate]="customTooltipTemplate"
            [contentTemplateContext]="{ $implicit: arg }"
          >
            @if (isMonthView) {
              <div class="fc-month-event-row">
                <span class="fc-month-event-time">{{
                  getMonthCardTime(arg.event)
                }}</span>
                <span class="fc-month-event-icon" aria-hidden="true">{{
                  getMonthCardIcon(arg.event)
                }}</span>
                <span class="fc-month-event-title">{{
                  (isTurnoCard ? getTurnoTitle(arg.event) : arg.event.title)
                    | titlecase
                }}</span>
              </div>
              @let monthSecondaryLine = getMonthCardSecondaryLine(arg.event);
              @if (monthSecondaryLine) {
                <div class="fc-month-event-secondary">
                  {{ monthSecondaryLine | titlecase }}
                </div>
              }
            } @else if (isAllDay) {
              <span class="event-allday-title">
                {{ getAllDaySummary(arg.event) }}
                @if (isUnresolved) {
                  <span class="event-unresolved-badge">⚠️ Nessun esito</span>
                }
              </span>
            } @else if (isTurnoCard || isAssenzaCard) {
              <div class="event-description">
                <span class="text-xs font-normal text-left">{{
                  getTurnoTimeRange(arg.event)
                }}</span>
              </div>
              <div class="event-title">
                {{
                  (isTurnoCard ? getTurnoTitle(arg.event) : arg.event.title)
                    | titlecase
                }}
              </div>
            } @else if (isPromemoriaCard) {
              <span class="event-short-time">{{
                getMonthCardTime(arg.event)
              }}</span>
              <span aria-hidden="true">{{ getMonthCardIcon(arg.event) }}</span>
              <span class="event-short-title">{{
                arg.event.title | titlecase
              }}</span>
            } @else if (isShortEvent) {
              <div class="event-short-line">
                @if (isMacchinarioCard) {
                  <span aria-hidden="true">⚙️</span>
                }
                <span class="event-short-time">{{
                  formatEventTimeRange(arg.event)
                }}</span>
                @if (isTravelCard) {
                  <span aria-hidden="true">🚗</span>
                }
                <span class="event-short-title">{{
                  (isMacchinarioCard
                    ? getMacchinarioCardBottomLine(arg.event)
                    : getEventCardBottomLine(arg.event)
                  ) | titlecase
                }}</span>
              </div>
            } @else {
              <div class="event-description">
                @if (isMacchinarioCard) {
                  <span aria-hidden="true">⚙️</span>
                }
                <span class="text-xs font-normal text-left mr-auto">{{
                  formatEventTimeRange(arg.event)
                }}</span>
                @if (canDragEvent) {
                  <span class="event-drag-handle" aria-hidden="true">⠿</span>
                }
              </div>
              <div class="event-title">
                @if (isTravelCard) {
                  <span aria-hidden="true">🚗</span>
                }
                {{
                  (isMacchinarioCard
                    ? getMacchinarioCardBottomLine(arg.event)
                    : getEventCardBottomLine(arg.event)
                  ) | titlecase
                }}
              </div>
            }
          </div>
        }
      </ng-template>
    </full-calendar>
  }
</section>
<ng-template #customTooltipTemplate let-arg>
  @let arePlaceholder = arg.event.extendedProps?.arePlaceholder;
  @let nomePaziente = arg.event.extendedProps?.nomePaziente;
  @let stato = arg.event.extendedProps?.stato;
  @let hasMatchingPrestazione =
    arg.event?.extendedProps?.hasMatchingPrestazione;
  @let isAssenza = isAssenzaEvent(arg.event);
  @let isTurno = isTurnoEvent(arg.event);
  @let isTravel = isTravelEvent(arg.event);
  @let tipoEventoNome =
    arg.event.extendedProps?.tipoEvento?.nome?.toLowerCase();
  @let isRiunione = tipoEventoNome === 'riunione';
  @let isPromemoria = isPromemoriaEvent(arg.event);
  @let descrizione = arg.event.extendedProps?.descrizione;
  @let hasColoredHeaderText =
    isAssenza ||
    isTurno ||
    isRiunione ||
    isPromemoria ||
    hasMatchingPrestazione;
  @if (!arePlaceholder) {
    <div
      class="min-w-80 max-w-md rounded-lg bg-white shadow-lg overflow-hidden"
    >
      <div
        class="flex justify-between items-center p-3"
        [ngClass]="{
          'bg-[#9E9E9E]': isAssenza,
          'bg-[#388E3C]': isTurno,
          'bg-[#C2185B]': isRiunione,
          'bg-[#F57C00]': isPromemoria,
          'bg-[#294A63]':
            !isAssenza &&
            !isTurno &&
            !isRiunione &&
            !isPromemoria &&
            hasMatchingPrestazione,
          'bg-[#CBE6FF]':
            !isAssenza &&
            !isTurno &&
            !isRiunione &&
            !isPromemoria &&
            !hasMatchingPrestazione,
        }"
      >
        <span
          class="font-semibold text-sm pr-3"
          [ngClass]="{
            'text-white': hasColoredHeaderText,
            'text-[#22191B]': !hasColoredHeaderText,
          }"
        >
          {{
            isTurno
              ? arg.event.extendedProps?.titolo || 'Turno'
              : (arg.event?.title | titlecase)
          }}
        </span>
        <span
          class="text-sm font-medium"
          [ngClass]="{
            'text-white': hasColoredHeaderText,
            'text-[#22191B]': !hasColoredHeaderText,
          }"
        >
          {{ formatEventTimeRange(arg.event) }}
        </span>
      </div>
      @if (isAssenza || isTurno || isRiunione || isPromemoria) {
        @if (isRiunione || isPromemoria) {
          <div class="p-3 pb-0 text-sm text-gray-700 space-y-1">
            <div class="flex items-center gap-2">
              <span aria-hidden="true">📅</span>
              <span>
                Dalle
                {{
                  arg.event.extendedProps?.realStart || arg.event.start
                    | date: 'HH:mm'
                }}
                del giorno
                {{
                  arg.event.extendedProps?.realStart || arg.event.start
                    | date: 'dd/MM/yyyy'
                }}
                alle
                {{
                  arg.event.extendedProps?.realEnd || arg.event.end
                    | date: 'HH:mm'
                }}
                del giorno
                {{
                  arg.event.extendedProps?.realEnd || arg.event.end
                    | date: 'dd/MM/yyyy'
                }}
              </span>
            </div>
          </div>
        }
        @if (descrizione) {
          <div
            class="p-3 text-sm text-gray-800 wrap-break-word whitespace-normal"
          >
            {{ descrizione }}
          </div>
        }
        @if (isRiunione || isPromemoria || isTurno) {
          <div
            class="flex justify-between items-center p-3 border-t border-gray-100 bg-gray-50"
          >
            <button
              mat-button
              color="primary"
              class="text-sm font-semibold"
              (click)="onClickEvent.emit(arg.event)"
            >
              <mat-icon class="mr-1" aria-hidden="true">visibility</mat-icon>
              Vedi dettagli
            </button>
            <button
              mat-button
              color="warn"
              class="text-sm font-semibold text-red-600 flex items-center"
              (click)="onClickEvent.emit(arg.event)"
            >
              <mat-icon class="mr-1" aria-hidden="true">delete</mat-icon>
              Elimina
            </button>
          </div>
        }
      } @else {
        <div class="p-3 text-gray-800">
          <div class="text-sm flex justify-between w-full">
            <div class="inline">
              <span> Paziente: </span>
              <span class="font-semibold">{{ nomePaziente | titlecase }} </span>
            </div>
          </div>
          @if (isEventInPast(arg.event) && hasMatchingPrestazione && stato) {
            <div class="text-sm">
              <span> Stato: </span>
              <span class="font-semibold">{{ stato | titlecase }}</span>
            </div>
          }
          @if (isAppuntamentoUnresolved(arg.event)) {
            <div class="text-sm text-red-600 font-medium mt-1">
              ⚠️ Nessun esito registrato
            </div>
          }
        </div>
        @let showManageActions =
          hasMatchingPrestazione && !isTravel && !hasEsitoRegistrato(arg.event);
        @let showDeleteAction = !isTravel && canDeleteEvent()(arg.event);
        @if (showManageActions || showDeleteAction) {
          <div
            class="flex justify-end gap-2 p-3 border-t border-gray-100 bg-gray-50"
          >
            @if (showManageActions) {
              <button
                mat-button
                color="primary"
                class="text-sm font-semibold"
                [disabled]="isEventInPast(arg.event)"
                [attr.aria-label]="'Pianificazione'"
                (click)="
                  manageEventAction.emit({
                    event: arg.event,
                    mode: 'pianificazione',
                  })
                "
              >
                <mat-icon class="mr-1" aria-hidden="true"
                  >edit_calendar</mat-icon
                >
                Pianificazione
              </button>
              <button
                mat-button
                color="primary"
                class="text-sm font-semibold"
                [attr.aria-label]="'Erogazione'"
                (click)="
                  manageEventAction.emit({
                    event: arg.event,
                    mode: 'erogazione',
                  })
                "
              >
                <mat-icon class="mr-1" aria-hidden="true"
                  >event_available</mat-icon
                >
                Erogazione
              </button>
            }
            @if (showDeleteAction) {
              <button
                mat-button
                color="warn"
                class="text-sm font-semibold text-red-600"
                [attr.aria-label]="'Elimina appuntamento'"
                (click)="
                  manageEventAction.emit({
                    event: arg.event,
                    mode: 'elimina',
                  })
                "
              >
                <mat-icon class="mr-1" aria-hidden="true">delete</mat-icon>
                Elimina
              </button>
            }
          </div>
        }
      }
    </div>
  }
</ng-template>
<!-- template for date range -->
<ng-template #dateRangeTemplate>
  @if (currentView()?.type === 'threeDay') {
    <mat-form-field appearance="outline">
      <mat-label>Seleziona un range di date</mat-label>
      <mat-date-range-input
        [formGroup]="range"
        [rangePicker]="picker"
        (dateChange)="goToDate()"
      >
        <input matStartDate formControlName="start" placeholder="Data da" />
        <input
          matEndDate
          formControlName="end"
          placeholder="Data a"
          (dateChange)="goToDate()"
        />
      </mat-date-range-input>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-date-range-picker #picker>
        <mat-datepicker-actions>
          <button mat-button matDatepickerCancel>Annulla</button>
          <button mat-button matDatepickerApply>Conferma</button>
        </mat-datepicker-actions>
      </mat-date-range-picker>
    </mat-form-field>
  }
</ng-template>
<!-- template for change view button -->
<ng-template #viewButtonTemplate>
  <button
    mat-stroked-button
    [matMenuTriggerFor]="menu"
    class="calendar-button calendar-view-button"
    [attr.aria-label]="currentView()?.label"
    [matTooltip]="'Clicca per cambiare la vista'"
  >
    {{ currentView()?.label }}
    <mat-icon aria-hidden="true">arrow_drop_down</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    @for (view of availableViews; track view) {
      <button mat-menu-item (click)="setView(view)">
        {{ view?.label }}
      </button>
    }
  </mat-menu>
</ng-template>

<!-- template for add prestazione button -->
<ng-template #addPrestazioneTemplate>
  <button
    matButton="filled"
    color="primary"
    [attr.aria-label]="'Aggiungi al calendario'"
    (click)="addPrestazioneClicked.emit(null)"
  >
    <mat-icon aria-hidden="true">add</mat-icon>
    Aggiungi al calendario
  </button>
</ng-template>
<!-- container for view button -->
<ng-container #viewButtonContainer> </ng-container>

<!-- Quick-add menu, anchored to the click point: absent from the DOM in
     'segnalazione' mode, which already opens its own dialog on dateClick. -->
@if (mode() !== 'segnalazione') {
  <siat-quick-add-menu
    [options]="quickAddMenuOptions()"
    (optionSelected)="onQuickAddOptionClick($event)"
  />
}
